// Main Layout with Sidebar and Header

import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sidebar } from '../components/Sidebar';
import { UserSettings } from '../components/UserSettings';
import { ChangePasswordModal } from '../components/ChangePasswordModal';
import { ConfirmationModal } from '../components/Common/ConfirmationModal';
import { useConfirmDialog } from '../hooks/useConfirmDialog';
import customerLogo from '../assets/customer-logo.svg';
import { VersionFooter } from '../components/VersionFooter';
import './MainLayout.css';

export function MainLayout() {
  const { user, logout, mustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);
  const { dialogState, showConfirm, handleConfirm, handleCancel } = useConfirmDialog();

  const handleLogout = async () => {
    showConfirm(
      'Abmelden',
      'Möchten Sie sich wirklich abmelden?',
      async () => {
        await logout();
        navigate('/login');
      },
      'warning'
    );
  };

  return (
    <div className="main-layout">
      <a href="#main-content" className="skip-link">
        Zum Hauptinhalt springen
      </a>

      <Sidebar />

      <div className="main-content">
        <header className="main-header" role="banner">
          <div className="header-left">
            <img
              src={customerLogo}
              alt="SCL Ehr Logo"
              className="customer-logo"
            />
            <h1 className="page-title">Vereinsverwaltung</h1>
          </div>

          <div className="header-right">
            <div className="user-info">
              <span className="user-name">{user?.fullName}</span>
              <span className="user-email">{user?.email}</span>
            </div>

            <button
              onClick={() => setShowSettings(true)}
              className="btn-icon"
              title="Einstellungen"
              aria-label="Einstellungen öffnen"
            >
              ⚙️
            </button>

            <button
              onClick={handleLogout}
              className="btn-logout"
              title="Abmelden"
              aria-label="Abmelden"
            >
              Abmelden
            </button>
          </div>
        </header>

        <main id="main-content" className="page-content" role="main" aria-label="Hauptinhalt">
          <Outlet />
        </main>

        <VersionFooter />
      </div>

      {showSettings && (
        <UserSettings onClose={() => setShowSettings(false)} />
      )}

      <ConfirmationModal
        isOpen={dialogState.isOpen}
        title={dialogState.title}
        message={dialogState.message}
        confirmText="Abmelden"
        cancelText="Abbrechen"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        type={dialogState.type}
      />

      {mustChangePassword && (
        <ChangePasswordModal />
      )}
    </div>
  );
}
